import { Link } from "react-router-dom";
import candidatesuData from "../../data/candidatesMenuData";
import employersData from "@/data/employerMenuData";
import { isActiveLink } from "../../utils/linkActiveChecker";

import { useDispatch, useSelector } from "react-redux";
import { menuToggle } from "../../features/toggle/toggleSlice";

import { useLocation } from "react-router-dom";
import { logoutUser } from "../../features/user/userSlice";
import { User } from "@/types/userTypes";

const DashboardSidebar = () => {
  const { pathname } = useLocation();
  const { menu } = useSelector((state: { toggle }) => state.toggle);
  const { user: me }: { user: User } = useSelector(
    (state: { user }) => state.user
  );
  const isWorker = me.type === "worker";

  const dispatch = useDispatch();
  // menu togggle handler
  const menuToggleHandler = () => {
    dispatch(menuToggle());
  };

  const data = isWorker ? candidatesuData : employersData;

  return (
    <div className={`user-sidebar ${menu ? "sidebar_open" : ""}`}>
      {/* Start sidebar close icon */}
      <div className="pro-header text-end pb-0 mb-0 show-1023 justify-content-end">
        <div className="fix-icon" onClick={menuToggleHandler}>
          <span className="flaticon-close"></span>
        </div>
      </div>
      {/* End sidebar close icon */}

      <div className="sidebar-inner">
        <ul className="navigation">
          {data.map((item) => (
            <li
              className={`${
                isActiveLink(item.routePath, pathname) ? "active" : ""
              } mb-1`}
              key={item.id}
              onClick={menuToggleHandler}
            >
              <Link
                to={item.routePath}
                onClick={
                  item.name === "Logout"
                    ? () => dispatch(logoutUser())
                    : () => {}
                }
              >
                <i className={`la ${item.icon}`}></i> {item.name}
              </Link>
            </li>
          ))}
        </ul>
        {/* End navigation */}
      </div>
    </div>
  );
};

export default DashboardSidebar;
